module.exports = __webpack_public_path__ + "static/media/mealArrowRight.8bca67f8.svg";